import React from "react";

/** Modale plein écran sur mobile (bas de page), centrée sur desktop. */
export const Modal = ({ title, onClose, children, testid }) => (
  <div className="fixed inset-0 z-50 bg-black/50 flex items-end md:items-center justify-center md:p-4 overflow-y-auto" onClick={onClose}>
    <div className="bg-white w-full md:max-w-lg rounded-t-[10px] md:rounded-[6px] border border-[#E4E7EB] shadow-lg max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid={testid}>
      <div className="flex items-center justify-between px-4 py-3 border-b border-[#E4E7EB] bg-[#F5F6F7] sticky top-0">
        <h3 className="font-semibold text-[#1F2933] text-base">{title}</h3>
        <button onClick={onClose} className="btn-ghost text-sm" aria-label="Fermer" data-testid={`${testid}-close`}>✕</button>
      </div>
      <div className="p-4 space-y-3 text-sm">{children}</div>
    </div>
  </div>
);

export const Motif = ({ value, onChange, placeholder, testid, required = true }) => (
  <div>
    <label className="label">Motif {required && <span className="text-[#C0392B]">* obligatoire</span>}</label>
    <textarea className="textarea" rows={3} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testid} />
  </div>
);
